// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3540":"NavigationBlock","8474":"HeroBlock"}[chunkId] + "." + {"3540":"04e5f8f9","8474":"35800a20"}[chunkId] + ".chunk.css";
};